<template>
  <div class="blind-box-home">
    <HomeHeader />
    <div class="home-start-guide">
      <img src="/static/img/blind-box/global/how-to-play-text-v4.webp" style="width: 95%" />
      <div class="start-button-container">
        <blind-box-button
          text="Tap to Start!"
          :background-color="'#FF014A'"
          :text-color="'#FFFFFF'"
          style="width: 400px; margin: 8px 0"
          @click="goToScanQrPage"
        />
        <span class="terms-and-condition-text" @click="isShowTncPopup = true">Syarat dan Ketentuan</span>
      </div>
    </div>
    <footer>
      <img src="/static/img/blind-box/global/footer-v2.webp" alt="Blind Box Footer" />
    </footer>
    <PopupTnc :is-visible="isShowTncPopup" @close="isShowTncPopup = false" />
  </div>
</template>
<script>
const Config = require('~/config/default.env').default;

export default {
  components: {
    HomeHeader: () => import('./layout/header.vue'),
    PopupTnc: () => import('./layout/tnc-popup.vue'),
    BlindBoxButton: () => import('./ui/blind-box-button.vue'),
  },
  data() {
    return {
      bulletIcon: '/static/img/blind-box/global/list-icon.svg',
      isShowTncPopup: false,
      storeDetail: null,
    };
  },
  mounted() {
    const cookieStoreDetail = Cookies.get('store_detail');
    if (!cookieStoreDetail || cookieStoreDetail === '') {
      this.$router.replace('/');
    }
    this.storeDetail = JSON.parse(cookieStoreDetail);
    this.checkOutOfStock();
  },
  methods: {
    goToScanQrPage() {
      this.$router.push('/blind-box/scan-qr');
    },
    checkOutOfStock() {
      const checkStockUrl = `${Config.MS_CATALOG_API_URL}/vending-machines/${this.storeDetail._id}`;
      this.$axios.get(checkStockUrl).then((response) => {
        if (response && response.data && response.data.data) {
          const productList = response.data.data.products;
          const availableProduct = productList.filter((prod) => prod.quantity > 0).length;
          if (availableProduct === 0) {
            this.$router.push('/blind-box/out-of-stock');
          }
        } else {
          this.$router.push('/blind-box/out-of-stock');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './font/font.scss';
$bg-gradient: linear-gradient(180deg, #327fff 0%, #b0ceff 100%);
$bg-gradient-size: 100vh;
$pole-image-background: url('/static/img/blind-box/global/pole.png') no-repeat bottom center;
$pole-size: 40px 90vh;

.blind-box-home {
  background: $pole-image-background, $bg-gradient;
  background-size: $pole-size, $bg-gradient-size;
  height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  footer {
    pointer-events: none;
    position: fixed;
    bottom: 0;
    width: 100%;
    max-height: 471px;
  }
}

.home-start-guide {
  background: #ffe8ea;
  border-radius: 40px;
  width: 80%;
  padding: 40px;
}

.start-button-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  .terms-and-condition-text {
    font-weight: 700;
    font-size: 30px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #000000;
  }
}
</style>
